$(document).ready(function () {

  $('.sportsIcons__slider').slick({
    nav: true,
    dots: true,
    swipe: true,
    vertical: true,
    rows: 2,
    slidesPerRow: 5,
    adaptiveHeight: true,
    arrows: true,
    prevArrow: '<button type="button" class="slick-prev"></button>',
    nextArrow: '<button type="button" class="slick-next"></button>'
    // onDragged: callback,
    // onChanged: callback
  });

  $('.whatWeDo__slides.owl-carousel').owlCarousel({
    items: 1,
    margin:0,
    stagePadding:0,
    nav: false,
    dots: false,
    autoplay: true,
		loop: true,
    smartSpeed: 450,
    mouseDrag: false
  });
	$('.partners').owlCarousel({
		items: 7,
		margin:0,
		stagePadding:0,
		nav: true,
		dots: true,
		loop: true,
		autoplay: true,
		smartSpeed: 650,
		mouseDrag: false,
		responsive : {
			1200 : {
					items:7
			},
			900 : {
					items:4
			},
			700 : {
					items:3
			},
			500 : {
					items:2
			},
			280 : {
				items: 1
			}
		}
	});

  $('.owl-carousel.one').owlCarousel({
    items: 1,
    margin:0,
    stagePadding:0,
    nav: false,
    dots: false,
    autoplay: true,
		loop: true,
    smartSpeed: 450,
    mouseDrag: false
  });

  $('.owl-carousel.two').owlCarousel({
    items: 1,
    margin:0,
    stagePadding:0,
    nav: false,
    dots: false,
    autoplay: true,
		loop: true,
    smartSpeed: 450,
    mouseDrag: false
  });

  $('.sportsIcons__slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    $('.sportsIcons__count--number .number').text(nextSlide + 1);
  });



  var rellax = new Rellax('.rellax', {
    center: true
  });

  var didScroll = false,
    header = document.querySelector('.header'),
    body = document.querySelector('html, body'),
    iebody = document.querySelector('body');
		container = document.querySelector('.mainContainer');


  function scrollTrue() {
    didScroll = true;
  }

  function isOnViewPoint() {
    if ((body.scrollTop || iebody.scrollTop) >= 100) {
      header.classList.add('short');
			container.classList.add('pat');
    } else {
      header.classList.remove('short');
			container.classList.remove('pat');
    }
  }

  window.addEventListener('scroll', scrollTrue);
  document.onscroll = scrollTrue();

  setInterval(function () {
    if (didScroll) {
      didScroll = false;
      isOnViewPoint();
    }
  });

  $(".js-up").on("click", function () {
    var body = $("html, body");
    body.stop().animate({
      scrollTop: 0
    }, 1500, 'swing');
  });
  $(window).on("scroll", function () {
    var scroll = $(window).scrollTop();
    if (scroll > 300) {
      $(".js-up").addClass("visible");
    } else {
      $(".js-up").removeClass("visible");
    }
  });



});
